import { atom } from "jotai";
import { nodesAtom } from "./nodesAtom";

export const hasSuggestedNodesAtom = atom((get) => {
  const nodes = get(nodesAtom);
  return nodes.some((node) => node.data.suggestedType);
});

hasSuggestedNodesAtom.debugLabel = "hasSuggestedNodesAtom";
